import React from 'react';
import { Menu } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';

export const UserMenu = ({ t }) => (
  <Menu>
    <Link to="/logout">{t('Logout')}</Link>
  </Menu>
);

UserMenu.propTypes = {
  t: propTypes.func
};
